import React from 'react';
import EinsteinChat from './Pages/botchat';
import { connect } from 'react-redux';
import './customizations/customizations.scss';

class App extends React.Component {

  render() {
    const { props: {
      backgroundColor,
      dispatch
    } } = this;


    return (

      <div id="app" className="root" style={{ backgroundColor }}>
        <EinsteinChat appDispatch={dispatch} />
      </div>
    )
  }
}

export default connect(
  ({ backgroundColor }) => ({ backgroundColor })
)(App)